import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress, 
  IconButton, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText, 
  Avatar, 
  Paper,
  Radio 
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import metaService from '../../../../services/metaService';

const MetaPageSelector = ({ authData, selectedPages, onPagesSelected }) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPageId, setSelectedPageId] = useState('');

  const fetchUserPages = async () => {
    setLoading(true);
    try {
      const userPages = await metaService.getUserPages(authData.tokenKey);
      // console.log('User pages fetched successfully:', userPages);
      if (userPages.success) {
        setPages(userPages.data.pages);
      }
    } catch (error) {
      console.error('Erro ao buscar páginas do usuário:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authData) {
      // console.log('Buscando páginas do usuário para:', authData);
      fetchUserPages();
    }
  }, [authData]);

  const handlePageSelect = (page) => {
    setSelectedPageId(page.id);
    onPagesSelected([page]);
  };

  const handleReload = () => {
    setSelectedPageId('');
    onPagesSelected([]);
    fetchUserPages();
  };

  return (
    <Box sx={{ mt: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="h5">
          Selecionar uma Página
        </Typography>
        <IconButton 
          onClick={handleReload} 
          disabled={loading || !authData}
          title="Recarregar páginas"
        >
          <Refresh />
        </IconButton>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper variant="outlined" sx={{ maxHeight: 400, overflow: 'auto' }}>
          <List>
            {pages.map((page) => (
              <ListItem key={page.id} disablePadding>
                <ListItemButton 
                  onClick={() => handlePageSelect(page)}
                  selected={selectedPageId === page.id}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(25, 118, 210, 0.1)',
                      '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.2)',
                      },
                    },
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    },
                  }}
                >
                  <Radio
                    edge="start"
                    checked={selectedPageId === page.id}
                    tabIndex={-1}
                    disableRipple
                    sx={{ mr: 1 }}
                  />
                  <Avatar 
                    src={page.picture?.data?.url} 
                    alt={page.name}
                    sx={{ width: 40, height: 40, mr: 2 }}
                  >
                    {page.name.charAt(0).toUpperCase()}
                  </Avatar>
                  <ListItemText 
                    primary={page.name}
                    secondary={`ID: ${page.id}`}
                    primaryTypographyProps={{ fontWeight: 'medium' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      
      {pages.length === 0 && !loading && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 3 }}>
          Nenhuma página encontrada
        </Typography>
      )}
    </Box>
  );
};

export default MetaPageSelector;